export default __webpack_public_path__ + "static/media/world.728459c1.png";